<template>
    <page-template page-id="SelectCompany" ref="super">

        <document-title :title="$tb('pages.selectCompany.documentTitle')"></document-title>

        <template v-slot:before v-if="isTitlebarActive">
          <titlebar :text="$tb('pages.selectCompany.title')"></titlebar>
        </template>

        <div class="ui column">

            <h4 class="custom-ui header" v-text="$t('pages.selectCompany.header')"></h4>
            <p v-html="$t( 'pages.selectCompany.subheader' )"></p>

            <div class="custom-ui chipped profile item">
              <div class="header">
                <i :class="usernameIcon"></i>
                <p id="username">{{ username }}</p>
              </div>
            </div>

            <messages id="Notifications" ref="postman"></messages>

            <template>
                <validated-field :show-errors-on="showErrors" :has-any-errors="$v.company.$invalid"
                                 :validation-rules="[{value: $v.company.required, msg: $t('common.validation.field.empty')}]">
                  <dropdown-mk2 id="companyId" name="companyId" v-model="$v.company.$model"
                                classes="ui fluid selection dropdown"
                                :placeholder="$t('common.label.company')"
                                :mandatory="true"
                                :options="companyOptions"></dropdown-mk2>
                </validated-field>
                <mandatory-label></mandatory-label>
            </template>
            <template>
                <div class="field">
                    <button id="continue" type="submit" @click.prevent="onContinue" class="ui fluid primary button">
                        {{$t('common.button.continue')}}
                    </button>
                </div>
            </template>
            <div class="field" v-if="getConfig('companiesPage_hasBackButton')">
                <button id="back" @click="goBack" class="ui fluid basic button">
                    {{$t('common.button.back')}}
                </button>
            </div>
        </div>
    </page-template>
</template>
<script>
import PageTemplate from './template/PageTemplate.vue'
import Titlebar from '../components/Titlebar.vue'
import DropdownMk2 from '../components/DropdownMk2.vue'
import Messages from '../components/Messages.vue'
import MandatoryLabel from '../components/MandatoryLabel.vue'
import ValidatedField from '../components/ValidatedField.vue'
import { mixin } from '../js/ciam-mixin.js'
import { brand } from '../js/brand.js'
import { required } from 'vuelidate/lib/validators'

export default {
  components: {
    PageTemplate,
    Titlebar,
    Messages,
    MandatoryLabel,
    ValidatedField,
    DropdownMk2
  },
  mixins: [mixin, brand],
  data: function () {
    return {
      company: '',
      showErrors: false
    }
  },
  props: {
    companies: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  validations () {
    return {
      company: { required }
    }
  },
  methods: {
    onContinue: function (e) {
      //  remove previous errors
      this.$refs.postman.clear()
      this.showErrors = false

      if (!this.isFormValid()) return
      this.$store.commit('companyName', this.companies[this.company])
      this.$refs.super.startLoading()
      console.info(`Selected company [companyId=${this.company}]`)
      this.$api.company.loadCompanyScopes(this.company, this.onSuccess, this.onFail)
    },
    isFormValid: function () {
      if (!this.$v.$anyDirty || this.$v.$anyError || this.$v.$invalid) {
        const _this = this

        this.focusFirstErrorField(function () {
          _this.showErrors = true
        })

        return false
      }

      return true
    },
    onSuccess: function (response) {
      this.handleRoutingResponse(response)
    },
    onFail: function (response) {
      this.onAjaxError(response)
      this.$refs.super.stopLoading()
    },
    goBack: function () {
      window.history.length > 1 ? window.history.back() : this.$router.push('/')
    },
    checkHideErrors: function () {
      if (this.$v.$invalid) return

      this.showErrors = false
    }
  },
  computed: {
    username: function () {
      return this.$store.state.username
    },
    usernameIcon: function () {
      if (!this.username) return ''
      return this.username.indexOf('@') > 0 ? 'mail icon' : 'phone icon'
    },
    companyOptions: function () {
      if (this.companies != null && Object.keys(this.companies).length > 0) {
        return {
          PRIVATE_USER: this.$tb('common.label.privateUser'),
          ...this.companies
        }
      } else {
        return {
          PRIVATE_USER: this.$tb('common.label.privateUser')
        }
      }
    }
  },
  mounted: function () {
    console.log('Display Companies Page')
  },
  watch: {
    $v: {
      handler () {
        this.checkHideErrors()
      },
      deep: true
    }
  }
}
</script>

<style scoped>
</style>
